import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant11PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 808 904",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M70.1221 125.642C146.473 92.8499 229.256 57.601 314.05 74.4883C376.194 86.8634 434.674 133.237 445.486 195.648C453.795 243.674 433.825 291.924 410.505 334.723C364.4 419.428 325.577 506.858 331.876 606.082C337.014 687.168 378.115 768.969 449.506 807.747C537.696 855.64 648.223 829.192 737.842 784.025",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant11PathwayIllustration as default };
